import React, { Fragment, Component }from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { NavLink } from 'react-router-dom';
import logo from '../../assets/images/logo@2x.png';
import { logoutUser } from '../auth/auth-actions';
import { StyledNavBar } from './styles';
import Icon from '../../common/svgs/Icon';

class TopNavBar extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render(){
    const { currentUser, dispatch } = this.props;
    return (
      <StyledNavBar className="app-navbar">
        <Navbar light expand="lg">
          <NavLink to="/dashboard" className="navbar-brand">
            {/* eslint-disable */}
          <img src={logo} alt="Trace Genomics Logo" />
        </NavLink>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="mr-auto" navbar >
            {this.props.isAuthenticated &&
              <Fragment>
                <NavItem className={this.state.isOpen ? 'open' : ''}>
                  <NavLink to="/dashboard" onClick={this.toggle}>Dashboard</NavLink>
                </NavItem>
                <NavItem
                  className={this.state.isOpen ? 'open' : ''}>
                  <NavLink
                    to="/submit" onClick={this.toggle}>Submit Samples</NavLink>
                </NavItem>
                <NavItem className={this.state.isOpen ? 'open' : ''}>
                  <NavLink to="/analytics" onClick={this.toggle}>Analytics</NavLink>
                </NavItem>
              </Fragment>
            }
          </Nav>
          <Nav navbar>
            {!this.props.isAuthenticated &&
              <Fragment>
                <NavItem className={this.state.isOpen ? 'open' : ''}>
                  <NavLink to="/register" onClick={this.toggle}>Register</NavLink>
                </NavItem>

                <NavItem className={this.state.isOpen ? 'open' : ''}>
                  <NavLink to="/login" onClick={this.toggle}>Login</NavLink>
                </NavItem>
              </Fragment>
            }
            {this.props.unreleasedVisible &&
            (
              <NavItem>
                <NavLink to='/growers'>View New App</NavLink>
              </NavItem>
            )}
            {this.props.isAuthenticated &&
              <UncontrolledDropdown nav inNavbar className={this.state.isOpen ? 'open' : ''}>
                <DropdownToggle nav >
                  {currentUser && currentUser.first_name ? currentUser.first_name : 'User'}
                  {/*<DownArrow />*/}
                  <Icon name='down arrow' width='15' className='down-arrow'/>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem tag="div">
                    <NavLink to="/my-account" onClick={this.toggle}>My Account</NavLink>
                  </DropdownItem>
                  <DropdownItem tag="div">
                  {/* TODO: reroute to current page, if page is non-authenticated */}
                    <NavLink
                      onClick={() => dispatch(logoutUser())}
                      to="/login">Logout</NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            }
          </Nav>
        </Collapse>
      </Navbar>
    </StyledNavBar>
  )
          }}

export default TopNavBar